export const FamilyUserAttributes = {
    OneTimeGiftCardSeen: 'One Time Gift Card Seen',
    OneTimeGiftCardSent: 'One Time Gift Card Sent',
    OneTimeGiftCardPopupSeen: 'One Time Gift Card Popup Seen',
};
